import { render, staticRenderFns } from "./CardRightColl.vue?vue&type=template&id=6ba7699e&scoped=true&"
import script from "./CardRightColl.vue?vue&type=script&lang=js&"
export * from "./CardRightColl.vue?vue&type=script&lang=js&"
import style0 from "./CardRightColl.vue?vue&type=style&index=0&id=6ba7699e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ba7699e",
  null
  
)

export default component.exports